import React from 'react';

export interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium',
  fullScreen = false,
  message
}) => {
  const sizeClasses = {
    small: 'loading-sm',
    medium: 'loading-md',
    large: 'loading-lg'
  };

  const spinnerSize = sizeClasses[size] || 'loading-md';
  
  const content = (
    <div className="flex flex-col items-center justify-center gap-4">
      <span className={`loading loading-spinner ${spinnerSize} text-primary`}></span>
      {message && <p className="text-base-content/60 text-sm">{message}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-base-100/90 z-[9999]">
        {content}
      </div>
    );
  }

  return content;
};
